// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__1pDV3","vLegacy":"SelectSecondary_vLegacy__2X_RV","error":"SelectSecondary_error__3WagV","disabled":"SelectSecondary_disabled__379gF"};